export function isElementValid(elment : any){
    return document.body.contains(elment);
}

export function removeElement(element) {
    if(element)
        element.remove();
}